import * as React from 'react';
import * as Recaptcha from 'react-recaptcha';
import * as Immutable from 'immutable'

import {NewsletterSignup} from '../../../api/newsletter/newsletterSignup'
import { SimpleFormInput } from '../../../utils/form/SimpleFormInput';
import { ValidationError } from '../../../types/types';

interface NewsletterSignupFormProps {
  recaptchakey:string
  onFinish:() => void
  onCancel: () => void
};

interface NewsletterSignupFormState {
  name:string,
  email:string,
  recaptchaResponse:string,
  working:boolean,
  errors: ValidationError[]
};

class NewsletterSignupForm extends React.Component<NewsletterSignupFormProps, NewsletterSignupFormState> {

  constructor(props:NewsletterSignupFormProps) {
    super(props);
    this.state = {
      name: "",
      email: "",
      recaptchaResponse: "",
      working: false,
      errors: []
    }
  }

  recaptchaInstance:Recaptcha = null;

  signUp(): void {
    this.setState({...this.state, working: true}, async () => {
      const response = await NewsletterSignup({
        email: this.state.email,
        name: this.state.name,
        recaptcharesponse: this.state.recaptchaResponse
      })
      this.setState({
        ...this.state,
        errors: response.errors,
        working: false
      }, () => {
        if(this.state.errors.length > 0) {
          this.recaptchaInstance.reset();
        } else {
          this.props.onFinish();
        }
      });
    })
  }

  canSubmitForm():boolean {
    return this.state.recaptchaResponse.length > 0
           && this.state.name.length > 0
           && this.state.email.length > 0
           && this.state.working === false
  }

  fieldContainsErrors(path:string):boolean {
    return this.state.errors.some(x => x.path === path);
  }

  errorMessage(path:string):string {
    const field = this.state.errors.find(x => x.path === path);
    if(field) {
      return field.message;
    } else {
      return "";
    }
  }

  public render():JSX.Element {

    return (
      <form className="simple_form new_form_newsletter_subscribe">
        <h2>{I18n.t("footer.newsletter.title")}</h2>
        <p>
          {I18n.t('simple_form.placeholders.form_newsletter_subscribe.info')}
        </p>
        <SimpleFormInput
            errors={Immutable.List(this.state.errors)}
            path="attributes.name"
            className="input string required form_newsletter_subscribe_name"
          >
          <input
            className="string required"
            type="text"
            value={this.state.name}
            onChange={(e) => {
              this.setState({...this.state, name: e.currentTarget.value});
            }}
            placeholder={I18n.t("simple_form.placeholders.form_newsletter_subscribe.name")}
          />
        </SimpleFormInput>
        <p />
        <p />
        <SimpleFormInput
            errors={Immutable.List(this.state.errors)}
            path="attributes.email"
            className="input string required form_newsletter_subscribe_email"
          >
          <input
            className="string required"
            type="text"
            placeholder={I18n.t("simple_form.placeholders.form_newsletter_subscribe.email")}
            value={this.state.email}
            onChange={(e) => {
              this.setState({...this.state, email: e.currentTarget.value})
            }}
          />
        </SimpleFormInput>
        <p />
        <SimpleFormInput
          errors={Immutable.List(this.state.errors)}
          path="attributes.base"
          >
          <Recaptcha
            ref={(elem) => this.recaptchaInstance = elem }
            sitekey={this.props.recaptchakey}
            verifyCallback={(response) => {
              this.setState({...this.state, recaptchaResponse: response});
            }}
            expiredCallback={() => {
              this.setState({...this.state, recaptchaResponse: ""});
            }}
          />
        </SimpleFormInput>
        <p />
        <input
          type="submit"
          className={`btn btn--primary ${this.canSubmitForm() == true ? "" : "disabled"}`}
          value={this.state.working ? I18n.t('crud.submitting') : I18n.t("helpers.submit.form_newsletter_subscribe.create") }
          onClick={(e) => {
            e.preventDefault();
            this.signUp();
          }}
          disabled={!this.canSubmitForm()}
        />
        <button
          className="btn btn--cancel"
          onClick={e => {
            e.preventDefault()
            this.props.onCancel()
          }}
        >
          {I18n.t('crud.cancel')}
        </button>
      </form>
    );
  }
}

export default NewsletterSignupForm;
